// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//---
export const environment = {
  production: false,
  serverUrl: 'https://citizexedgeserviceqa.azurewebsites.net/',
  clientUrl: 'https://dev.citizex.ai/',
  version: '1.0',
  Date: '2026',
  //todaUrl: 'https://citizex.coresee.com/'
  todaUrl: 'https://qa.coresee.com/',
  webSocketEndPoint: 'https://citizexwebsocketserviceqa.azurewebsites.net/',
  veriffApiKey: 'b0f81b9e-fd96-48fb-8acb-5f7db5c97e91',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
